import {
  BatchNhkMarcRegConditionListItem,
  BatchNhkMarcRegConditionListItemFromJSON
} from '@/api/models/batch/BatchNhkMarcRegConditionListItem'

export interface BatchNhkMarcRegPageLoadResult {
  items: BatchNhkMarcRegConditionListItem
}

export function BatchNhkMarcRegPageLoadResultFromJSON(
  json: any
): BatchNhkMarcRegPageLoadResult {
  return {
    items: BatchNhkMarcRegConditionListItemFromJSON(json)
  }
}
